import Stack from '@mui/material/Stack';

import NewAccountForm from '../auth/NewAccountForm/NewAccountForm';

const NewPatientScreen = props => {
  return (
    <Stack width='100%' alignItems='center'>
      <NewAccountForm {...props} />
    </Stack>
  );
};

export default NewPatientScreen;
